module.exports = __webpack_public_path__ + "24312fa90e5f2b69ba1e2268697ecb2f.woff";